import $ from 'jquery';
export const init = async function() {
    if ($('body').attr('data-shopify-template') === 'page-faq') {
        $(document).ready(function() {
            // check url to redirect to particular section
            const section_hash = document.location.hash;
            if (section_hash !== '') {
                // mobile
                if (($(window).width() || 0) < 1025) {
                    const sectionItem = $(section_hash).offset();
                    $([
                        document.documentElement,
                        document.body
                    ]).animate({
                        scrollTop: sectionItem !== undefined ? sectionItem.top - 200 : null
                    }, 2000);
                } else {
                    $('.FAQ-categories-btn .scroll[href="' + section_hash + '"]').click();
                }
            }
            // Open and close accordion
            $('.FAQ-tab').click(function() {
                $(this).toggleClass('active').siblings().removeClass('active');
            });
            const scrollLink = $('.scroll');
            // Smooth scrolling
            scrollLink.click(function(e) {
                var _$_attr;
                e.preventDefault();
                const href = ((_$_attr = $(this).attr('href')) === null || _$_attr === void 0 ? void 0 : _$_attr.toString()) || '';
                const section = $(href).offset();
                if (window.matchMedia('(max-width: 1024px)').matches) {
                    $('body,html').animate({
                        scrollTop: section !== undefined ? section.top - 166 : 0
                    }, 1000);
                } else {
                    $('body,html').animate({
                        scrollTop: section !== undefined ? section.top : 0
                    }, 1000);
                }
            });
            // Active link switching
            $(window).scroll(function() {
                const scrollbarLocation = $(this).scrollTop() || 0;
                scrollLink.each(function() {
                    var _$_attr;
                    const href = ((_$_attr = $(this).attr('href')) === null || _$_attr === void 0 ? void 0 : _$_attr.toString()) || '';
                    const section = $(href).offset();
                    const sectionOffset = section !== undefined ? section.top - 35 : 0;
                    if (sectionOffset <= scrollbarLocation) {
                        $(this).parent().addClass('active');
                        $(this).parent().siblings().removeClass('active');
                    }
                });
            });
        });
        const navbar = document.getElementById('mobile-categories');
        if (navbar === null) {
            return;
        }
        const sticky = navbar.offsetTop || 0;
        const myFunction = ()=>{
            if (navbar === null) {
                return;
            }
            if (window.pageYOffset >= sticky) {
                navbar.classList.add('sticky');
            } else {
                navbar.classList.remove('sticky');
            }
        };
        window.onscroll = function() {
            myFunction();
        };
    }
};
